import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

export default function ArticleCard({ article, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      whileHover={{ y: -4 }}
      className="bg-terminalLight rounded-xl p-6 border border-terminalBorder hover:border-accentBlue/30 transition-colors"
    >
      <p className="text-xs text-accentBlue font-mono font-medium mb-2">
        {article.date}
      </p>
      <h3 className="text-lg font-semibold text-brightText mb-2">
        {article.title}
      </h3>
      <p className="text-dimText text-sm leading-relaxed mb-4">
        {article.excerpt}
      </p>
      <Link
        to={`/articles/${article.slug}`}
        className="inline-flex items-center gap-2 text-sm font-medium text-accentBlue hover:text-neonBlue transition-colors"
      >
        Read more <FiArrowRight size={14} />
      </Link>
    </motion.div>
  );
}
